// HACK: Phase4Step2-2終了間際にESLintのルールが変更になり、ロジックは変更出来なかったため回避。
/* eslint-disable max-lines */
/********************************/
/*          About vuex          */
/********************************/
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';
import config from '../../../../share/config';
import session from '../../../../share/session';
import individualDiagnose from '../../../../share/util/individualDiagnose';
import customTable from '../../../../share/components/vue/PaginationTable';
import individualWorkSupportUtil from '../../../../share/util/individualWorkSupportUtil';
import utils from "../../../../share/util/utils";
import error from '../../../../common/nodejs/errors';

// 検索条件
const SEARCH_YEAR_RANGE = 1;
const SEARCH_MONTH_RANGE = 12;

/** 各フェーズ定義 */
const PHASE = {
  STANDBY: 'standby',
  START: 'start',
  DEL_CHK: 'delChk',
  NOT_EXIST: 'notExist',
  SUCCESS: 'success',
  WRITE_FAILED: 'writeFailed',
  FAILED: 'failed'
};

export default {
  name: 'requirement047',
  data() {
    return {
      phase: PHASE.STANDBY,
      isLoading: false,
      /** 一覧画面でOKボタン押下可否フラグ */
      selectedDestination: false,
      /** 現在データ書込み時に使用する（readAPIで保存したdata_id） */
      executeDataID: null,
      /** APIから取得した機能リストを常に保持しておく */
      originalDataList: [],
      /** 画面に表示する為の機能リスト */
      filteredDataList: [],
      /** 選択中のコード */
      selectedData: {},
      /** backへ送るDataID（現在データ書き込み時以外） */
      SendBackDataID: '',
      /** 保存日時（年）フィルター選択リスト */
      searchYearOptions: [''],
      /** 保存日時（月）フィルター選択リスト */
      searchMonthOptions: [''],
      /** フィルター用テキスト */
      selectedYear: '',
      selectedMonth: '',
      filterRegistrant: '',
      filterDataId: '',
      /** 読み出しデータ */
      dataIdReadData: '',
      systemId: '',
      /** 削除選択されたデータのリスト */
      selectedItems: [],
      selectedItem: undefined,
      // ダイアログフラグ
      modal_requirement_047: false
    };
  },

  components: {
    'custom-table': customTable
  },

  props: {
    i18nWsKey: { type: String, default: '', required: true },
    workSupportId: { type: Number, default: '', required: true },
  },

  computed: {
    ...mapState({
      language: state => state.systems.language,
      netAppId: state => state.netAppConnector.pairingAppId,
      vehicleInfo: state => state.cache.vehicleInfo
    }),

    /** ダイアログのヘッダー色 */
    headerColor() {
      switch (this.phase) {
        case PHASE.FAILED:
        case PHASE.NOT_EXIST:
        case PHASE.WRITE_FAILED:
          return 'danger';
        case PHASE.SUCCESS:
          return 'success';
        case PHASE.STANDBY:
        case PHASE.START:
        case PHASE.DEL_CHK:
        default:
          return 'secondary';
      }
    },

    /** Tableヘッダ */
    systemTableColumns() {
      return [
        { name: 'registered_at', label: this.i18nWsKey + '.label_registered' },
        { name: 'vin', label: this.i18nWsKey + '.label_vin' },
        { name: 'registered_by', label: this.i18nWsKey + '.label_registrant' },
        { name: 'data_id', label: this.i18nWsKey + '.label_data_id' },
        { name: 'delete', label: this.i18nWsKey + '.label_data_delete', useButton: true },
      ];
    },

    /** モーダルのサイズ */
    modalSize() {
      switch (this.phase) {
        case PHASE.START:
          return 'xl';
        default:
          return 'md';
      }
    },
  },

  methods: {
    ...mapActions('auth', ['logout', 'resetSession']),

    /** 初期化処理 */
    init() {
      // EUCキーの取得
      this.systemId = individualDiagnose.getCurrentSystemId(this);
      this.modal_requirement_047 = true;
      // 初期の検索条件の設定（現在の年）
      const currentYear = new Date().getFullYear();
      // 空白(全年検索用)+今年+去年を選択できるような選択肢配列を作成
      this.searchYearOptions = [''].concat([...Array(SEARCH_YEAR_RANGE + 1)].map((_, i) => String(currentYear - i)));
      // 空白(全月検索用)+1月-12月を選択できるような選択肢配列を作成
      this.searchMonthOptions = [''].concat([...Array(SEARCH_MONTH_RANGE)].map((_, i) => String(i + 1)));
      // テーブル情報の更新
      this.updateTable();
    },

    /**
    * API 通信で共通バリデーションでエラーが発生した際のコールバック
    * @param {object} result バリデーション結果
    */
    validateErrorResult(result) {
      individualDiagnose.apiErrorDefaultAction(
        this,
        result,
        // ログアウト処理のコールバック
        (self) => { self; this.logout(this); },
        // セッションリセット処理のコールバック
        (self) => { self; this.resetSession(this); },
        // その他エラー発生のコールバック
        (result) => { result; this.showUnexpectedError(); },
      );
    },

    /** 選択したデータの読み出しデータ */
    clickRow: async function (selected) {
      this.selectedData = selected;
      this.SendBackDataID = selected.data_id;
      this.setHighLight();
      this.selectedDestination = true;

      // ユーザが選択したデータの読み出しデータを表示する
      const filteredItem = this.filteredDataList.find(item => item.data_id === this.selectedData.data_id);

      if (filteredItem) {
        const showDat = await individualWorkSupportUtil.getReadOutData(this, this.systemId, filteredItem);
        this.dataIdReadData = showDat;
      }
    },

    /**
     * 一覧データ表示（削除時考慮）
     * @param {*} flg 削除確認画面でキャンセルボタン押下：false
     */
    async setData(flg) {
      try {
        this.isLoading = true;
        // カスタムテーブルの描画の為sleep処理を実施
        await utils.sleep(1000);
        if (flg) {
          // 見た目上、選択行を削除
          this.filteredDataList = this.filteredDataList.filter(item => !this.selectedItems.includes(item.data_id));
        } else {
          this.filteredDataList = this.filteredDataList.filter(item => {
            // 翻訳後の名称を大文字・小文字区別なくフィルターする
            // 削除対象は表示しない
            const yearFilter = this.selectedYear.toLowerCase();
            const monthFilter = this.selectedMonth.toLowerCase();
            const itemYear = new Date(item.registered_at).getFullYear().toString();
            const itemMonth = new Date(item.registered_at).getMonth() + 1;

            return (
              (yearFilter === "" || itemYear.includes(yearFilter)) &&
              (monthFilter === "" || itemMonth === Number(monthFilter)) &&
              item.registered_by.toLowerCase().includes(this.filterRegistrant.toLowerCase()) &&
              item.data_id.toLowerCase().includes(this.filterDataId.toLowerCase()) &&
              !this.selectedItems.includes(item.data_id)
            );
          });
        }
        //一覧画面OKボタン押下フラグ、フィルター、選択データ、読み出しデータを初期化
        this.selectedDestination = false;
        this.filterRegistrant = '';
        this.filterDataId = '';
        this.selectedData = '';
        this.SendBackDataID = '';
        this.dataIdReadData = '';
      } finally {
        this.isLoading = false;
      }
    },

    /** 選択状態を解除し、フィルターの文字列に応じてリストをフィルターする */
    searchFilter() {
      this.dataIdReadData = '';
      this.selectedDestination = false;
      this.selectedData = {};
      this.setHighLight();

      this.filteredDataList = this.originalDataList.filter(item => {
        // 翻訳後の名称を大文字・小文字区別なくフィルターする
        // 削除対象は表示しない
        const yearFilter = this.selectedYear.toLowerCase();
        const monthFilter = this.selectedMonth.toLowerCase();
        const itemYear = new Date(item.registered_at).getFullYear().toString();
        const itemMonth = new Date(item.registered_at).getMonth() + 1;

        return (
          (yearFilter === "" || itemYear.includes(yearFilter)) &&
          (monthFilter === "" || itemMonth === Number(monthFilter)) &&
          item.registered_by.toLowerCase().includes(this.filterRegistrant.toLowerCase()) &&
          item.data_id.toLowerCase().includes(this.filterDataId.toLowerCase()) &&
          !this.selectedItems.includes(item.data_id)
        );
      });
    },

    /** テーブル情報の取得を行う */
    async standby(key = null) {
      try {
        this.isLoading = true;
        // WS2保存データ読み出し (要求)（バックエンドAPI_POST）
        const token = session.getToken();
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'standby',
            last_evaluated_key: key
          },
          // エラー発生のコールバックを実装
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列が返ってくる。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
            case config.STATUS_WSP_FAILED:
              // ポーリングが正常に完了した場合：一覧データ取得処理を行う
              if(response.data.user_data.last_evaluated_key){
                this.filteredDataList = this.filteredDataList.concat(response.data.user_data.read_data);
                await this.standby(JSON.stringify(response.data.user_data.last_evaluated_key));
              } else {
                this.filteredDataList = this.filteredDataList.concat(response.data.user_data.read_data);
              }
              this.phase = PHASE.START;
              // テーブル情報の更新
              this.updateTable();
              // 表示          
              this.setData(true);
              break;
            default:
              this.phase = PHASE.START;
          }
        }

      } finally {
        this.isLoading = false;
      }
    },

    /** テーブル情報の更新を行う */
    async updateTable() {
      try {
        this.isLoading = true;
        let cnv_registered_at = '';

        // registered_at(unixtime)をYYYY/MM/DD HH:mm:ss形式に変換
        this.filteredDataList.forEach(item => {
          cnv_registered_at = utils.timeConverter(item.registered_at);
          item.registered_at = cnv_registered_at;
          item.buttonVisible = true;
        });

        this.originalDataList = this.filteredDataList;
        this.searchFilter();

      } finally {
        this.isLoading = false;
      }
    },

    /** 削除確認画面でOK押下時及びカスタマイズデータ書き込み成功時イベント */
    async delete() {
      try {
        this.isLoading = true;
        const token = session.getToken();

        // 初期処理 (要求)（バックエンドAPI_POST）
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'delete',
            data_id: this.SendBackDataID
          },
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); }
        );

        if (response) {
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
            case config.STATUS_WSP_FAILED:
            default:
              // ポーリングが正常に完了した場合
              // 削除確認画面でOK押下時は書込一覧確認画面を表示、カスタマイズデータ書き込み成功時は完了画面を表示
              if (this.phase === PHASE.DEL_CHK) {
                // 非表示レコード追加
                this.selectedItems.push(this.selectedItem.data_id);
                this.dataIdReadData = '';
                this.phase = PHASE.START;
                this.selectedData = {};
                this.setHighLight();
                // 表示（削除レコード考慮）
                this.setData(true);
              } else {
                this.phase = PHASE.SUCCESS;
              }
          }
        }

      } finally {
        this.isLoading = false;
      }
    },

    /** データ読み出し */
    async read() {
      try {
        this.isLoading = true;
        const token = session.getToken();

        // 現在データ読み出し処理 (要求)（バックエンドAPI_POST）
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'read',
            data_id: this.SendBackDataID
          },
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); }
        );

        if (response) {
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // 取得リクエストid保持  ※現在データ書き込み時に使用するrequest_id
              this.executeDataID = response.data.user_data.request_id;
              // カスタマイズデータ書き込み処理
              await this.write();
              break;
            case config.STATUS_WSP_FAILED:
            default:
              // 異常終了
              switch (response.data.async_code) {
                case error.WSP_047_DB_READ_DATA_INFO_NOT_FOUND:
                  // WS2存在なしの場合 データ削除済エラー画面を表示
                  this.phase = PHASE.NOT_EXIST;
                  break;
                default:
                  this.showUnexpectedError();
                  break;
              }
          }
        }

      } finally {
        this.isLoading = false;
      }
    },

    /** データ書き込み */
    async write() {
      try {
        this.isLoading = true;
        const token = session.getToken();

        // 初期処理 (要求)（バックエンドAPI_POST）
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'write',
            data_id: (this.phase === PHASE.START) ? this.SendBackDataID : this.executeDataID,
            is_rewrite: (this.phase === PHASE.START) ? false : true
          },
          // エラー発生のコールバック
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバック
          (result) => { this.validateErrorResult(result); }
        );

        if (response) {
          // ポーリングが正常に完了した場合
          switch (response.data.status) {
            case config.STATUS_WSP_COMPLETED:
              // カスタマイズデータ書き込み時はデータ削除処理、でなければ終了処理
              if (this.phase === PHASE.START) {
                await this.delete();
                break;
              } else {
                await this.exit();
                break;
              }
            case config.STATUS_WSP_FAILED:
              // カスタマイズデータ書き込み時は一部完了画面を表示、でなければ共通エラー画面を表示
              if (this.phase === PHASE.START) {
                this.phase = PHASE.WRITE_FAILED;
                break;
              } else {
                this.showUnexpectedError();
                break;
              }
            default:
              this.showUnexpectedError();
          }
        }

      } finally {
        this.isLoading = false;
      }
    },

    /** 終了処理 */
    async exit() {
      try {
        this.isLoading = true;
        const token = session.getToken();

        // DefaultSession遷移 (要求)（バックエンドAPI_POST）
        const response = await individualWorkSupportUtil.pollingWspApi(
          this,
          this.netAppId,
          this.systemId,
          this.workSupportId,
          {
            id_token: token.id_token,
            type: 'exit'
          },
          // エラー発生のコールバックを実装する。
          // ここでは利用していないが、引数の errorType にはあらかじめ用意された定数文字列、もしくは独自定義した文字列が返ってくる。
          // 必要に応じて、errorType に応じてメッセージを変えるといったことも可能。
          (errorType) => { errorType; this.showUnexpectedError(); },
          // POST API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
          // GET API 結果が異常の場合（handler.validate でエラーが発生した場合）のコールバックを定義する（validateErrorResult の中は同様のため、省略する）
          (result) => { this.validateErrorResult(result); },
        );

        if (response) {
          // 結果に関わらず、Wizardを閉じる
          this.closeWizard();
        }

      } finally {
        this.isLoading = false;
      }
    },

    /** その他エラーの表示 */
    showUnexpectedError() {
      // 共通エラー画面からの"failed"はWizardを閉じる、でなければ共通エラー画面を表示
      if (this.phase === PHASE.FAILED) {
        this.closeWizard();
        return;
      }
      this.phase = PHASE.FAILED;
    },

    /**
     * 行選択削除
     * @param {object} selected 選択した行の情報
     */
    deleteRow(selected) {
      // 削除確認ダイアログを表示
      this.selectedItem = selected;
      this.SendBackDataID = selected.data_id;
      this.phase = PHASE.DEL_CHK;
    },

    /** 削除確認画面でOKクリックイベント */
    delOk() {
      this.delete();
    },

    /** 削除確認画面でキャンセルクリックイベント */
    delCancel() {
      this.dataIdReadData = '';
      this.phase = PHASE.START;
      this.selectedData = {};
      this.setHighLight();
      this.setData(false);
    },

    /** 選択している機能のハイライト設定 */
    setHighLight() {
      this.filteredDataList.forEach(item => {
        if (item === this.selectedData) {
          item.fieldSpec = {};
          item.fieldSpec.registered_at = config.LIST_ITEM_HIGHLIGHT;
          item.fieldSpec.vin = config.LIST_ITEM_HIGHLIGHT;
          item.fieldSpec.registered_by = config.LIST_ITEM_HIGHLIGHT;
          item.fieldSpec.data_id = config.LIST_ITEM_HIGHLIGHT;
          item.fieldSpec.delete = config.LIST_ITEM_HIGHLIGHT;
          item.fieldSpec.locale_key = config.LIST_ITEM_HIGHLIGHT;
        } else {
          if (item.fieldSpec) {
            delete item.fieldSpec;
          }
        }
      });
    },

    /** Wizardを閉じる */
    async closeWizard() {
      this.$emit('close-wizard');
      this.modal_requirement_047 = false;
    }
  },

  async mounted() {
    this.init();
    this.standby();
  },
};